export default "__VITE_PUBLIC_ASSET__f806f050__"